import React, { FunctionComponent } from "react";
import { WithTranslation, withTranslation } from "react-i18next";
import styled from "styled-components";
import { AccountState } from "Types/state";
import TermsAndPrivacyLinks from "./TermsAndPrivacyLinks";

const TRANSLATION_KEY = "UserAccount.TermsAndPrivacy.CaTermsAndPrivacy";

const Root = styled("div")`
    color: ${(props) => props.theme.palette.grey[60]};
    font-size: 0.8em;
    font-weight: normal;
    line-height: 1.5em;
    margin: 1em 2em;
    text-align: left;
`;

const ErrorMessage = styled("div")`
    border: 1px solid ${(props) => props.theme.palette.error.main};
    color: ${(props) => props.theme.palette.error.main};
    font-weight: bold;
    margin: 0.4em auto;
    padding: 0.4em 1.5em;
    text-align: center;
`;

const PromotionsCheckBoxContainer = styled("div")`
    margin-top: ${(props) => props.theme.spacing.unit}px;
`;

const LinksContainer = styled("div")`
    margin-bottom: ${(props) => props.theme.spacing.unit * 2}px;
    margin-top: ${(props) => props.theme.spacing.unit * 3}px;
    text-align: center;
`;

interface Props {
    account: AccountState;
    optInMarketing: boolean;
    optInTransactional: boolean;
    onAgreeTransactionalClick?: (answer: boolean) => void;
    onAgreePromotionalClick?: (answer: boolean) => void;
}

const CaTermsAndPrivacy: FunctionComponent<Props & WithTranslation> = ({
    account,
    optInMarketing,
    optInTransactional,
    onAgreeTransactionalClick,
    onAgreePromotionalClick,
    t,
}) => {
    function handleAgreeTransactionalOnClick(e: React.ChangeEvent<HTMLInputElement>) {
        onAgreeTransactionalClick && onAgreeTransactionalClick(e.target.checked);
    }

    function handleAgreePromotionalOnClick(e: React.ChangeEvent<HTMLInputElement>) {
        onAgreePromotionalClick && onAgreePromotionalClick(e.target.checked);
    }

    const accountName = account.name;

    return (
        <Root>
            <div>
                <input
                    type="checkbox"
                    id="terms_agree_transactional"
                    checked={optInTransactional}
                    onChange={handleAgreeTransactionalOnClick}
                />
                {t(`${TRANSLATION_KEY}.optInTransactionalTerms`)}
            </div>

            {!optInTransactional && (
                <ErrorMessage>{t(`${TRANSLATION_KEY}.optInTransactionalErrorMessage`)}</ErrorMessage>
            )}

            <PromotionsCheckBoxContainer>
                <input
                    type="checkbox"
                    id="terms_agree_promotional"
                    checked={optInMarketing}
                    onChange={handleAgreePromotionalOnClick}
                />
                {t(`${TRANSLATION_KEY}.optInMarketingTerms`, { accountName })}
            </PromotionsCheckBoxContainer>

            <LinksContainer>
                <TermsAndPrivacyLinks />
            </LinksContainer>
        </Root>
    );
};

export default withTranslation()(CaTermsAndPrivacy);
